export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'SET_STYLES_CONFIG': {
      return payload;
    }
    default:
      return state;
  }
};
